import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";

import { useStyles } from "../../../../../Components/CSS/TableStyle.css";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import DecreaseStockBody from "../DecreaseStockBody/DecreaseStockBody";
import AddDecreaseStock from "../AddDecreaseStock/AddDecreaseStock";

class ViewDecreaseStock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 10,
      page: 0,
      search: {
        categoryName: "",
      },
      decreases: [],
      detailStatus: false,
      detailData: [],
      isEmpty: false,
      decreasedData: {
        quantity: 0,
        remarks: "",
        date: new Date(),
      },
    };
  }

  handleChange = (e) => {
    this.setState({
      decreasedData: {
        ...this.state.decreaseData,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleEditData = (data) => {
    this.setState({
      decreasedData: {
        quantity: data.quantity,
        remarks: data.remarks,
        date: data.date,
      },
    });
  };

  handleDetailStatus = (detailData) => {
    this.setState({
      detailStatus: true,
      detailData,
    });
  };

  handleCancelDetail = () => {
    this.setState({
      detailStatus: false,
    });
  };

  handleSearch = (e) => {
    this.setState({
      search: {
        ...this.state.search,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { rowsPerPage, page } = this.state;
    // const filtered = this.state.categories.filter((item) => {
    //   return (
    //     item.categoryName
    //       .toLowerCase()
    //       .indexOf(this.state.search.categoryName.toLowerCase()) !== -1
    //   );
    // });
    return (
      <div>
        <TableContainer>
          <Table>
            <CustomTableHead column={this.props.column} />

            <TableBody>
              <AddDecreaseStock
                decreasedData={this.state.decreasedData}
                handleChange={this.handleChange}
                categoryId={this.props.categoryId}
                getCategoryDetails={this.props.getCategoryDetails}
              />
              {this.props.decreases.length !== 0 &&
                (rowsPerPage > 0
                  ? this.props.decreases.slice(
                      rowsPerPage * page,
                      rowsPerPage * page + rowsPerPage
                    )
                  : this.props.decreases
                ).map((decreaseData, index) => (
                  <DecreaseStockBody
                    data={decreaseData}
                    key={index}
                    index={index}
                    categoryId={this.props.categoryId}
                    decreasedData={this.state.decreasedData}
                    handleChange={this.handleChange}
                    handleEditData={this.handleEditData}
                    handleDetailStatus={this.handleDetailStatus}
                    getCategoryDetails={this.props.getCategoryDetails}
                  />
                ))}
            </TableBody>

            <CustomTableFooter
              count={this.props.decreases.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={this.handlePage}
              onChangeRowsPerPage={this.handleRowsPerPage}
            />
          </Table>
        </TableContainer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(ViewDecreaseStock)));
